import api from './axios';

export function listLeaveCalendar(start, end) {
  return api.get('/leave-calendar', { params: { start, end } }).then((r) => r.data);
}

export function listLeaveAssignableUsers() {
  return api.get('/leave-calendar/assignable-users').then((r) => r.data);
}

export function createLeaveCalendar(body) {
  return api.post('/leave-calendar', body).then((r) => r.data);
}

export function acknowledgeLeave(id, acknowledged = true) {
  return api.put(`/leave-calendar/${id}/acknowledge`, { acknowledged }).then((r) => r.data);
}

export function deleteLeaveEntry(id) {
  return api.delete(`/leave-calendar/${id}`).then((r) => r.data);
}
